import type { Module } from 'vuex';
import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import type { ILessonPerformanceReportState } from '@/store/modules/report/lesson-performance-report/types';
import type { RootState } from '@/store/types';

const namespaced: boolean = true;

export const lessonPerformanceReportModule: Module<ILessonPerformanceReportState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
